
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { StrategyProvider } from "@/types/strategy-types";

interface ProviderSelectionProps {
  userRole?: string | null;
  providerId: string | null;
  providers: StrategyProvider[];
  value: string;
  onChange: (value: string) => void;
}

export const ProviderSelection = ({
  userRole,
  providerId,
  providers,
  value,
  onChange
}: ProviderSelectionProps) => {
  // For admins, show provider selection dropdown
  if (userRole === 'admin') {
    return (
      <div className="space-y-2">
        <Label htmlFor="provider">Strategy Provider</Label>
        <Select
          value={value}
          onValueChange={onChange}
          required
        >
          <SelectTrigger>
            <SelectValue placeholder="Select a provider" />
          </SelectTrigger>
          <SelectContent>
            {providers.map(provider => (
              <SelectItem key={provider.id} value={provider.id}>
                {provider.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }
  
  // For strategy providers, show read-only field with their provider
  if (userRole === 'strategy_provider' && providerId) {
    return (
      <div className="space-y-2">
        <Label htmlFor="provider">Strategy Provider</Label>
        <Input
          id="provider"
          value={providers.find(p => p.id === providerId)?.name || 'Your Provider'}
          disabled
        />
        <input
          type="hidden"
          name="strategy_provider_id"
          value={providerId}
        />
      </div>
    );
  }
  
  // Fallback - empty div to maintain layout
  return <div></div>;
};
